function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  version: "1.1",
  id: "Layer_1",
  xmlns: "http://www.w3.org/2000/svg",
  x: "0",
  y: "0",
  viewBox: "0 0 36.5 42.7",
  xmlSpace: "preserve"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M31.1 30.4c6.9-7 6.8-18.2-.4-25.1s-18.5-6.6-25.4.4c-6.8 6.9-6.8 17.8 0 24.7v.1l.1.1.1.1 11.2 11.1c.8.8 2 .8 2.8 0l11.2-11.1.1-.1.3-.2c0 .1 0 .1 0 0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.2 23.3c.9 0 1.4-.5 1.4-1.5l.3-9.8c0-.5-.1-.9-.5-1.2-.3-.3-.7-.5-1.2-.5s-.9.2-1.2.5c-.3.3-.5.7-.4 1.2l.2 9.8c0 1 .5 1.5 1.4 1.5zm0 6.1c.5 0 1-.2 1.4-.6.4-.4.6-.8.6-1.4 0-.5-.2-1-.6-1.4-.4-.4-.9-.6-1.4-.6-.5 0-1 .2-1.4.6-.4.4-.6.8-.6 1.4 0 .5.2 1 .6 1.4.4.4.9.6 1.4.6z",
  fill: "#FFF"
})));